(function () {
    'use strict';
    angular.module('AngularAdmin')

        .directive('pdCustomerOrderCalendar', ['$rootScope', function ($rootScope) {
            return {
                restrict: "E",
                templateUrl: '/static/partials/customer_order_calendar.html',
                controller: "CustomerOrderCalendarCtrl",
                replace: true,
                scope: true,
                require: 'pdCalendar',
                link: function ($scope, $element, $attr) {

                    $scope.isHoveredOrderBundle = function (order_date) {
                        return order_date && order_date.order.id && $scope.hoveredOrderBundle == order_date.order.id;
                    };

                    $scope.setHoveredOrderBundle = function (order_date) {
                        $scope.hoveredOrderBundle = order_date && order_date.order.id;
                    };

                    $scope.hoveredOrderBundle = null;

                    $scope.isHoveredOrderRequestBundle = function (order_date) {
                        return order_date && order_date.order_request.id && $scope.hoveredOrderRequestBundle == order_date.order_request.id;
                    };

                    $scope.setHoveredOrderRequestBundle = function (order_date) {
                        $scope.hoveredOrderRequestBundle = order_date && order_date.order_request.id;
                    };

                    $scope.hoveredOrderRequestBundle = null;
                }
            };
        }])

        .directive('pdCustomerOrderCalendarDayCell', [function () {
            return {
                restrict: "A",
                templateUrl: '/static/partials/customer_order_calendar_day_cell.html',

                link: function ($scope, $element, $attr) {
                    //
                    // Scope Functions
                    //

                    //
                    // Init
                    //
                    $scope.isTopCell = $attr.istopcell == 'true';
                }
            };
        }]);
})();
